import { render, staticRenderFns } from "./TecResumeView.vue?vue&type=template&id=47089d1d&scoped=true&"
import script from "./TecResumeView.vue?vue&type=script&lang=js&"
export * from "./TecResumeView.vue?vue&type=script&lang=js&"
import style0 from "./TecResumeView.vue?vue&type=style&index=0&id=47089d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47089d1d",
  null
  
)

export default component.exports